<template>
  <div class="app">
    <router-view :tiempo="tiempo" :ciudad="ciudad"/>
  </div>
</template>


<script>
export default {
  name: 'app',
  components: {},
  props: ['findLocation'],
  data() {
    return {
      geolocation: {
        lat: null,
        lon: null
      },
      ciudad: null,
      tiempo: {
        temperatura: null,
        nubes: null,
        lluvia: null,
        viento: null,
        main: null
      }
    }
  },
  watch: {
    geolocation() {
      this.getWeather();
    },
  },
  created() {
    this.getPosition(); 
  },
  mounted() {
  },
  methods: {
    getPosition() {
      let that = this;
      getGeolocation();
      function getGeolocation() {
        if (localStorage.getItem('coords')){
          that.geolocation = JSON.parse(localStorage.getItem('coords'));
          console.log(that.geolocation);
        }
        if (navigator.geolocation) {
          return navigator.geolocation.getCurrentPosition(
            browserGeolocationSuccess,
            browserGeolocationFail,
            {maximumAge: 20000, timeout: 10000, enableHighAccuracy: false}
          );
        } else {
          console.log("Navigator geolocation unavailable.");
        }
      }
      function browserGeolocationSuccess(position) {
        console.log("Browser geolocation success!\n\nlat = " + position.coords.latitude + "\nlng = " + position.coords.longitude);
          that.geolocation.lat = position.coords.latitude;
          that.geolocation.lon = position.coords.longitude;
          localStorage.setItem('coords', JSON.stringify(that.geolocation));
      }
      function browserGeolocationFail(error) {
          switch (error.code) {
              case error.TIMEOUT:
                console.log("Browser geolocation error !\n\nTimeout.");
              break;
              case error.PERMISSION_DENIED:
                if(error.message.indexOf("Only secure origins are allowed") == 0) {
                    tryAPIGeolocation();
                } else {
                    console.log("Permison denied");
                }
              break;
              case error.POSITION_UNAVAILABLE:
                console.log("Browser geolocation error !\n\nPosition unavailable.");
              break;
          }
      }
      function tryAPIGeolocation() {
          fetch("https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyDCa1LUe1vOczX1hO_iGYgyo8p_jYuGOPU", {
              method: "GET", 
          }).then(success => {
              apiGeolocationSuccess({coords: {latitude: success.location.lat, longitude: success.location.lng}});
          }).catch(err => {
              console.log("API Geolocation error! \n\n"+err);
              // this.$emit("geolocationError",  "API Geolocation error! \n\n"+err);
          })
      }
      function apiGeolocationSuccess(position) {
          that.geolocation.lat = position.coords.latitude;
          that.geolocation.lon = position.coords.longitude;
          console.log("API geolocation success!\n\nlat = " + that.geolocation.lat + "\nlng = " + that.geolocation.lon);
          localStorage.setItem('coords', JSON.stringify(that.geolocation));
      }
    },
    async getWeather() {
      const base_url = 'https://api.openweathermap.org/data/2.5/onecall?';
      let coords = `lat=${this.geolocation.lat}&lon=${this.geolocation.lon}`;
      let units = '&units=metric';
      let apikey = '&appid=74c095d84c7951a36bf4b3fe9148ab93';
      const full_url = base_url + coords + units + apikey;

      const data = await fetch(full_url).then(res => res.json());
      console.log(data);
      this.tiempo.temperatura = data.current.feels_like;
      this.tiempo.nubes = data.current.clouds;
      this.tiempo.viento = data.current.wind_speed;
      this.tiempo.lluvia = (data.hourly[0].pop + data.hourly[1].pop + data.hourly[2].pop + data.hourly[3].pop) / 4;
      this.tiempo.main = data.daily[0].weather[0].main;
      this.tiempo.resto = data;
      this.ciudad = data.timezone;
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.app {
  position: relative;
  width: unquote('min(100%,700px)');
  height: 100vh;
  // max-height: 667px;
  background-image: url('./assets/fondo.jpg');
  background-size: cover;
  @media (min-width: 700px) {
    max-width: 400px;
    margin: 2rem auto;
  }
}
</style>
